﻿const cssClassesToApply = {
  paid: {
    base: 'nhs-c-marker',
    selected: 'nhs-c-marker--selected',
    viewed: 'nhs-c-marker--viewed',
  },
  spotlight: {
    base: 'nhs-c-marker--spotlight',
    selected: 'nhs-c-marker--spotlight-selected',
    viewed: 'nhs-c-marker--spotlight-viewed',
  },
  noPrice: {
    base: 'nhs-c-marker__no-price',
    selected: 'nhs-c-marker__no-price--selected',
    viewed: 'nhs-c-marker__no-price--viewed',
  },
  priceReduction: {
    base: 'nhs-c-marker--price-off',
    selected: '',
    viewed: '',
  },
  basic: {
    base: 'nhs-c-marker-basic',
    selected: 'nhs-c-marker-basic--selected',
    viewed: 'nhs-c-marker-basic--viewed',
  },
};

const getStateClasses = (markerTypeClasses, isSelected, isViewed) => ({
  base: markerTypeClasses.base,
  selected: isSelected ? markerTypeClasses.selected : null,
  viewed: isViewed ? markerTypeClasses.viewed : null,
});

const getClassesToApply = ({ isBasic, isNoPrice, isSpotlight, isPriceReduction, isSelected, isViewed }) => {
  const classesToReturn = {
    base: [],
    selected: [],
    viewed: [],
  };

  if (isBasic) {
    const { basic } = cssClassesToApply;
    const { base, selected, viewed } = getStateClasses(basic, isSelected, isViewed);
    classesToReturn.base.push(base);
    classesToReturn.selected.push(selected);
    classesToReturn.viewed.push(viewed);
    return classesToReturn;
  }

  if (isNoPrice) {
    const { noPrice } = cssClassesToApply;
    const { base, selected, viewed } = getStateClasses(noPrice, isSelected, isViewed);
    classesToReturn.base.push(base);
    classesToReturn.selected.push(selected);
    classesToReturn.viewed.push(viewed);
  }

  if (isSpotlight) {
    const { spotlight } = cssClassesToApply;
    const { base, selected, viewed } = getStateClasses(spotlight, isSelected, isViewed);
    classesToReturn.base.push(base);
    classesToReturn.selected.push(selected);
    classesToReturn.viewed.push(viewed);
  }

  if (isPriceReduction && !isNoPrice) {
    const { priceReduction } = cssClassesToApply;
    const { base } = getStateClasses(priceReduction, isSelected, isViewed);
    classesToReturn.base.push(base);
  }

  if (!isNoPrice) {
    const { paid } = cssClassesToApply;
    const { base, selected, viewed } = getStateClasses(paid, isSelected, isViewed);
    classesToReturn.base.push(base);
    classesToReturn.selected.push(selected);
    classesToReturn.viewed.push(viewed);
  }

  return classesToReturn;
};

export default getClassesToApply;
